// extracted by mini-css-extract-plugin
export default {"cardContainer":"HomeProductCard_cardContainer__UPZDW","productImage":"HomeProductCard_productImage__OkhXB","name":"HomeProductCard_name__nXdkE"};